import { render, staticRenderFns } from "./view-comment-upload.vue?vue&type=template&id=3cb73953&scoped=true&"
import script from "./view-comment-upload.vue?vue&type=script&lang=js&"
export * from "./view-comment-upload.vue?vue&type=script&lang=js&"
import style0 from "./view-comment-upload.vue?vue&type=style&index=0&id=3cb73953&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb73953",
  null
  
)

export default component.exports